import React from 'react';

/**
 * Toggle component for switching between vocabulary view modes.
 *
 * Three modes:
 *   - 'custom'  -> tenant's per-line-item vocabulary
 *   - 'csi50'   -> MasterFormat 2004+ (~50 divisions, default for GCs)
 *   - 'csi15'   -> MasterFormat 1995 (16 divisions)
 *
 * The component name is unchanged for backward compatibility with existing
 * imports; despite the name it now exposes all three options.
 *
 * Backward-compat: callers passing the old 'modern'/'legacy' values will
 * still work -- 'modern' maps to 'csi50' and 'legacy' to 'csi15'. The
 * onToggle callback always receives the new-style id ('custom'|'csi50'|'csi15').
 */
const LEGACY_MODE_ALIAS = {
  modern: 'csi50',
  legacy: 'csi15',
};

const MODES = [
  { id: 'custom', label: 'Custom' },
  { id: 'csi50', label: 'CSI 50' },
  { id: 'csi15', label: 'CSI 15' },
];

export function MasterFormatViewToggle({ viewMode, onToggle, className = '' }) {
  const normalized = LEGACY_MODE_ALIAS[viewMode] || viewMode || 'csi50';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-gray-600 dark:text-gray-300 whitespace-nowrap">Format:</span>
      <div className="inline-flex rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 p-0.5">
        {MODES.map((mode) => {
          const isActive = normalized === mode.id;
          return (
            <button
              key={mode.id}
              type="button"
              onClick={() => onToggle(mode.id)}
              className={`px-3 py-1 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
                isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            >
              {mode.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
